import { render } from "./Row.vue?vue&type=template&id=513a62da&scoped=true"
import script from "./Row.vue?vue&type=script&lang=js"
export * from "./Row.vue?vue&type=script&lang=js"

import "./Row.vue?vue&type=style&index=0&id=513a62da&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-513a62da"],['__file',"src/components/Row.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "513a62da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('513a62da', __exports__)) {
    api.reload('513a62da', __exports__)
  }
  
  module.hot.accept("./Row.vue?vue&type=template&id=513a62da&scoped=true", () => {
    api.rerender('513a62da', render)
  })

}


export default __exports__